<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">CONTENTS</p>
<p class="toc"><a href="#/html/9780292798489_08_ch1">BACKGROUND AND PROSPECT</a></p>
<p class="toc"><span href="#/html/9780292798489_10_ch2" title="Link target outside of Sample">I. SCIENCE AND REALITY</span></p>
<p class="toc"><span href="#/html/9780292798489_11_ch3" title="Link target outside of Sample">II. AUTHORITY AND CONSCIENCE</span></p>
<p class="toc"><span href="#/html/9780292798489_13_ch4" title="Link target outside of Sample">III. DEDICATION OR SERVITUDE</span></p>
<p class="toc1"><span href="#/html/9780292798489_14_ch5" title="Link target outside of Sample">APPENDIX</span></p>
<p class="toc"><span href="#/html/9780292798489_14_ch5#sec1" title="Link target outside of Sample">1. PREMISSES OF SCIENCE</span></p>
<p class="toc"><span href="#/html/9780292798489_14_ch5#sec2" title="Link target outside of Sample">2. SIGNIFICANCE OF NEW OBSERVATIONS</span></p>
<p class="toc"><span href="#/html/9780292798489_14_ch5#sec3" title="Link target outside of Sample">3. CORRESPONDENCE WITH OBSERVATION</span></p>
<p class="toc1"><span href="#/html/9780292798489_15_not" title="Link target outside of Sample">NOTES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292798489_05_toc.vue?251da708